import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from './utils/enhancedAuthTokenHttp';

export type TrendDirection = 'up' | 'down' | 'neutral';

export interface DashboardCountersResponse {
  loansProcessed: {
    count: number;
    unresolved: number;
  };
  documentsFiled: {
    count: number;
    touchless: number;
    trend: TrendDirection;
  };
  dataVerified: {
    count: number;
    touchless: number;
    trend: TrendDirection;
  };
  qualityCheck: {
    count: number;
    touchless: number;
    trend: TrendDirection;
  };
}

const getDashboardCounters = async (): Promise<DashboardCountersResponse> => {
  if (isMockServices()) return await mock(_mockData, { delay: 500 });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    data: DashboardCountersResponse;
  }>('/counters/dashboard', {
    method: 'GET',
  });
  if (response.data?.data) return response.data.data;
  throw new Error('Failed to fetch dashboard counters');
};

export default getDashboardCounters;

const _mockData: DashboardCountersResponse = {
  loansProcessed: {
    count: 124,
    unresolved: 15,
  },
  documentsFiled: {
    count: 845,
    touchless: 0.85,
    trend: 'up',
  },
  dataVerified: {
    count: 12045,
    touchless: 0.1,
    trend: 'neutral',
  },
  qualityCheck: {
    count: 4231,
    touchless: 0.98,
    trend: 'down',
  },
};
